var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login',{staticClass:"login",attrs:{"resetPasswordUrl":"https://signin.empathybroker.com/reset_password_request.html","scheduledEvents":_vm.scheduledEvents},on:{"login":function($event){return _vm.$emit('login', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }